import { useQuery } from '@tanstack/react-query';
import { api } from './client';
import type { OrderChannel } from './types';

/**
 * "Geçmişten fiyat öner" (`urunler`) — sunucu ucu: `apps/api/src/products/products.controller.ts`
 * `GET /api/products/price-suggestions`. Para alanları STRING'dir; panel hesap yapmaz, yalnız
 * gösterir ve "Uygula" ile mevcut `useProductMutations().update`'e taşır.
 */
export interface PriceSuggestionChannel {
  channel: OrderChannel;
  median: string;
  samples: number;
}

export interface PriceSuggestionRow {
  productId: string;
  name: string;
  suggested: string | null;
  byChannel: PriceSuggestionChannel[];
  samples: number;
  method: 'single' | 'derived' | null;
}

export function useProductPriceSuggestions(all = false) {
  return useQuery({
    queryKey: ['product-price-suggestions', all],
    queryFn: () =>
      api.get<{ items: PriceSuggestionRow[] }>(
        `/api/products/price-suggestions${all ? '?all=1' : ''}`,
      ),
    enabled: false, // yalnız kullanıcı "Geçmişten fiyat öner" düğmesine bastığında (refetch) çalışır
  });
}
